import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  OrderedList,
  ListItem,
  Link,
  useColorModeValue,
} from "@chakra-ui/react";

const PrivacyPolicy = () => {
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const textColor = useColorModeValue("gray.800", "gray.100");
  const headingColor = useColorModeValue("gray.900", "white");

  return (
    <Box bg={bgColor} minH="100vh" pt="60px">
      <Container maxW="4xl" py={8}>
        <VStack spacing={6} align="stretch">
          <Heading
            as="h1"
            size="xl"
            textAlign="center"
            color={headingColor}
            fontFamily="'Roboto', sans-serif"
            fontSize={{ base: "25px", md: "30px", lg: "36px" }}
            mb={5}
            textDecoration="underline"
          >
            Privacy Policy
          </Heading>

          <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
            <Text as="span" fontWeight="bold">
              Effective Date:
            </Text>{" "}
            (Insert Launch Date)
          </Text>
          <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
            Thank you for visiting{" "}
            <Text as="span" fontWeight="bold">
              Business Automation Limited's
            </Text>{" "}
            website and digital platforms. This Privacy Policy explains how we
            collect, use, and protect your personal data when you interact with
            our website, mobile application, and digital services.
          </Text>
          <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
            By accessing or using our platform, you acknowledge that you have
            read and agreed to this Privacy Policy.
          </Text>

          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              1. Information We Collect
            </Heading>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              We may collect personal and non-personal information in the
              following ways:
            </Text>
            <OrderedList
              spacing={2}
              ml={5}
              color={textColor}
              fontFamily="'Roboto', sans-serif"
              styleType="lower-alpha"
              sx={{
                "& li::marker": {
                  fontWeight: "bold",
                },
              }}
            >
              <ListItem>
                <Text as="span" fontWeight="bold">
                  Personal Information:
                </Text>{" "}
                When you contact us, submit forms, or use our services, we may
                collect details such as your name, email address, contact
                number, organization, and any other information you voluntarily
                provide.
              </ListItem>
              <ListItem>
                <Text as="span" fontWeight="bold">
                  Device Information:
                </Text>{" "}
                When you access our website or mobile app, we may collect
                technical data including your device type, operating system, IP
                address, browser type, mobile network details, and hardware
                identifiers.
              </ListItem>
              <ListItem>
                <Text as="span" fontWeight="bold">
                  Log and Usage Data:
                </Text>{" "}
                Our servers automatically record certain data such as pages
                visited, duration of visits, referring URLs, and timestamps.
                This helps us monitor performance and enhance user experience.
              </ListItem>
              <ListItem>
                <Text as="span" fontWeight="bold">
                  Cookies and Tracking Technologies:
                </Text>{" "}
                We use cookies and similar technologies to analyze usage
                patterns and improve our platform’s functionality. You may
                choose to disable cookies through your browser settings;
                however, some features may not function properly if cookies are
                disabled. This helps us monitor performance and enhance user
                experience.
              </ListItem>
            </OrderedList>
          </Box>

          {/* <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              Use of Information
            </Heading>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              We use the information we collect to:
            </Text>
            <OrderedList
              spacing={2}
              ml={5}
              color={textColor}
              fontFamily="'Roboto', sans-serif"
              styleType="disc"
            >
              <ListItem>
                Respond to inquiries and provide customer support.
              </ListItem>
              <ListItem>
                Improve our website, products, and service performance.
              </ListItem>
              <ListItem>
                Send updates, newsletters, or promotional communications (you may opt out at any time).
              </ListItem>
              <ListItem>
                Ensure security, prevent fraud, and comply with applicable laws.
              </ListItem>
              <ListItem>
                Analyze user behavior and service usage to enhance overall experience.
              </ListItem>
            </OrderedList>
          </Box> */}

          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              3. Legal Basis for Processing
            </Heading>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              We process your personal data under one or more of the following
              bases:
            </Text>
            <OrderedList
              spacing={2}
              ml={5}
              color={textColor}
              fontFamily="'Roboto', sans-serif"
              styleType="disc"
            >
              <ListItem>
                <Text as="span" fontWeight="bold">
                  Consent:
                </Text>{" "}
                When you provide information voluntarily or subscribe to
                communications.
              </ListItem>
              <ListItem>
                <Text as="span" fontWeight="bold">
                  Legitimate Interest:
                </Text>{" "}
                To improve our services, ensure platform security, and conduct
                analytics.
              </ListItem>
              <ListItem>
                <Text as="span" fontWeight="bold">
                  Legal Obligation:
                </Text>{" "}
                To comply with applicable laws or regulatory requirements.
              </ListItem>
            </OrderedList>
          </Box>
          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              4. Data Retention
            </Heading>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              We retain your personal data only for as long as necessary to
              fulfill the purposes outlined in this policy, or as required by
              applicable laws. When information is no longer needed, it is
              securely deleted or anonymized.
            </Text>
          </Box>

          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              5. Data Sharing and Disclosure
            </Heading>
            <Text color={textColor} mb={2} fontFamily="'Roboto', sans-serif">
              We do not sell or rent your personal data.
            </Text>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              We may share data only in the following situations:
            </Text>
            <OrderedList
              spacing={2}
              ml={5}
              color={textColor}
              fontFamily="'Roboto', sans-serif"
              styleType="disc"
            >
              <ListItem>
                With{" "}
                <Text as="span" fontWeight="bold">
                  trusted third-party service providers
                </Text>{" "}
                who support our operations (e.g., hosting, analytics, or
                customer support), under confidentiality agreements.
              </ListItem>
              <ListItem>
                When required by law or to protect the rights, property, or
                safety of Business Automation Limited, our users, or the public.
              </ListItem>
            </OrderedList>
          </Box>

          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              6. Data Security
            </Heading>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              We implement strict administrative, technical, and physical
              measures to protect your information against unauthorized access,
              disclosure, alteration, or destruction.
            </Text>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              Our platform uses{" "}
              <Text as="span" fontWeight="bold">
                encryption
              </Text>
              ,{" "}
              <Text as="span" fontWeight="bold">
                firewall protection
              </Text>
              , and{" "}
              <Text as="span" fontWeight="bold">
                industry-standard security protocols
              </Text>
              . However, no online transmission or storage system is completely
              secure, and we cannot guarantee absolute protection.
            </Text>
          </Box>

          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              7. Your Rights
            </Heading>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              You have the right to:
            </Text>
            <OrderedList
              spacing={2}
              ml={5}
              color={textColor}
              fontFamily="'Roboto', sans-serif"
              styleType="disc"
            >
              <ListItem>Access the personal data we hold about you.</ListItem>
              <ListItem>
                Request correction or deletion of your information.
              </ListItem>
              <ListItem>
                Withdraw your consent for processing (where applicable).
              </ListItem>
              <ListItem>
                Lodge a complaint with the relevant data protection authority.
              </ListItem>
            </OrderedList>
            <Text color={textColor} mt={4} fontFamily="'Roboto', sans-serif">
              To exercise these rights, please contact us using the details
              below.
            </Text>
          </Box>

          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              8. Third-Party Links and Services
            </Heading>
            <Text color={textColor} mb={1} fontFamily="'Roboto', sans-serif">
              Our platform may contain links to third-party websites or
              services.
            </Text>
            <Text color={textColor} mb={1} fontFamily="'Roboto', sans-serif">
              We are not responsible for the content, security, or privacy
              practices of those websites.
            </Text>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              Please review their privacy policies before sharing any personal
              data.
            </Text>
          </Box>

          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              9. Changes to This Policy
            </Heading>
            <Text color={textColor} mb={1} fontFamily="'Roboto', sans-serif">
              We may update this Privacy Policy from time to time to reflect
              changes in our practices or applicable regulations.
            </Text>
            <Text color={textColor} mb={1} fontFamily="'Roboto', sans-serif">
              The revised version will be posted on this page with an updated
              effective date.
            </Text>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              We encourage users to review this page periodically.
            </Text>
          </Box>

          <Box>
            <Heading
              as="h2"
              size="lg"
              color={headingColor}
              fontFamily="'Roboto', sans-serif"
              fontSize={{ base: "18px", md: "20px", lg: "24px" }}
              mt={5}
              mb={3}
            >
              10. Contact Us
            </Heading>
            <Text color={textColor} mb={4} fontFamily="'Roboto', sans-serif">
              If you have any questions, concerns, or requests regarding this
              Privacy Policy, please contact us:
            </Text>
            <VStack align="start" spacing={2} mb={4}>
              <Text color={textColor} fontFamily="'Roboto', sans-serif">
                <Text as="span" fontWeight="bold">
                  Business Automation Limited
                </Text>
              </Text>
              <Text color={textColor} fontFamily="'Roboto', sans-serif">
                BDBL Bhaban, Level 6, 12 Kawran Bazar, Dhaka-1215, Bangladesh
              </Text>
              <Text color={textColor} fontFamily="'Roboto', sans-serif">
                📧 Email:{" "}
                <Text as="span" fontWeight="bold">
                  info@ba-systems.com
                </Text>
              </Text>
              <Text color={textColor} fontFamily="'Roboto', sans-serif">
                🌐 Website:{" "}
                <Link
                  href="https://ba-systems.com"
                  color="#000B8C"
                  textDecoration="underline"
                  fontWeight="bold"
                >
                  https://ba-systems.com
                </Link>
              </Text>
              <Text color={textColor} fontFamily="'Roboto', sans-serif">
                📞 Phone:{" "}
                <Text as="span" fontWeight="bold">
                  09602666777
                </Text>
              </Text>
            </VStack>
            <Text
              color={textColor}
              fontFamily="'Roboto', sans-serif"
              fontSize="sm"
              textAlign="center"
              mt={6}
            >
              © Business Automation Limited. All rights reserved.
            </Text>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
